import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useRepsOutletContext } from 'pages/Reps'
import { useParams } from 'react-router-dom'
import { reps } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirRep() {
    const { id } = useParams()
    const { data } = useRepsOutletContext()
    const r = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = reps.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!r) return null

    const handleSubmit = () =>
        mutateAsync(r.id, {
            onSuccess: () => {
                toast.success('Rep excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="auto"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'Reps'])}
        >
            <Dialog.Content>
                Realmente deseja excluir o REP {r.numeroSerie}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
